import React, { lazy } from 'react';

const PaymentOptionsComponent = lazy(
  () => import(/* webpackChunkName: "carvana-purchase-payment-options" */ './payment-options')
);

export const PaymentOptionsRoute = () => {
  return <PaymentOptionsComponent />;
};
